import {gql} from 'apollo-angular';

export const GET_USER_INFO = gql`
  query GetUserInfo {
    userinfo {
      id
      username,
      firstname,
      lastname,
      email,
      title {
        id
        shortName
        description
      }
      roles {
        id,
        roleName
      }
    }
  }
`;
